<script setup>
/**
 * Como conectar uma caixa do WhatsApp Cortex ZNew: QR Code ou código digitado no celular.
 * Usado na criação da caixa e na aba de conexão das configurações (o legado não tem código).
 */
import { useI18n } from 'vue-i18n';

defineProps({ disabled: { type: Boolean, default: false } });
const model = defineModel({ type: String, default: 'qr' }); // 'qr' | 'code'
const { t } = useI18n();

const methods = [
  {
    value: 'qr',
    icon: 'i-lucide-qr-code',
    label: 'INBOX_MGMT.BAILEYS_PAIRING.METHOD_QR',
    description: 'INBOX_MGMT.BAILEYS_PAIRING.METHOD_QR_DESC',
  },
  {
    value: 'code',
    icon: 'i-lucide-smartphone',
    label: 'INBOX_MGMT.BAILEYS_PAIRING.METHOD_CODE',
    description: 'INBOX_MGMT.BAILEYS_PAIRING.METHOD_CODE_DESC',
  },
];
</script>

<template>
  <fieldset :disabled="disabled" :class="{ 'opacity-60': disabled }">
    <legend class="text-sm font-semibold text-n-slate-12 mb-2">
      {{ t('INBOX_MGMT.BAILEYS_PAIRING.CONNECT_HOW') }}
    </legend>
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <label
        v-for="method in methods"
        :key="method.value"
        class="flex items-start gap-3 p-3 rounded-lg outline outline-1 cursor-pointer hover:outline-n-slate-7 has-[:focus-visible]:outline-2 has-[:focus-visible]:outline-n-brand"
        :class="
          model === method.value
            ? 'outline-n-brand bg-n-alpha-1'
            : 'outline-n-weak'
        "
      >
        <input
          v-model="model"
          type="radio"
          name="connect-method"
          :value="method.value"
          class="sr-only"
        />
        <span
          class="size-5 mt-0.5 flex-shrink-0 text-n-slate-11"
          :class="[method.icon, { 'text-n-brand': model === method.value }]"
          aria-hidden="true"
        />
        <span class="flex flex-col gap-0.5 text-left">
          <span class="text-sm font-medium text-n-slate-12">{{
            t(method.label)
          }}</span>
          <span class="text-sm text-n-slate-11">{{
            t(method.description)
          }}</span>
        </span>
      </label>
    </div>
  </fieldset>
</template>
